import React from "react";
import { Routes, Route } from "react-router-dom";

import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import List from "./List";
import AddEdit from "./AddEdit";
import Details from "./AddEdit";
import { Header, Grid, Button } from "semantic-ui-react";

import { CLEAR_WEB_API_LOG_DATA } from "constants/actions";

function WebApiLog() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  function clearData() {
    dispatch({
      type: CLEAR_WEB_API_LOG_DATA,
      payload: null,
    });
    setTimeout(() => {
      navigate(`/app/web-api-log/new`);
    }, 500);
  }

  return (
    <>
      <Grid.Row columns={2}>
        <Grid.Column>
          <Header as="h2" style={{ marginTop: "50px" }}>
            Web Api Pull Log
            <Header.Subheader>
              Api pull for getting data in the system.
            </Header.Subheader>
          </Header>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column>
          {location.pathname !== "/app/web-api-log/new" && (
            <Button primary onClick={clearData}>
              Add New
            </Button>
          )}
        </Grid.Column>
      </Grid.Row>
      <Routes>
        <Route path="/" element={<List />} />
        <Route path="new" element={<AddEdit />} />
        <Route path="details/:id" element={<Details />} />
      </Routes>
    </>
  );
}

export default WebApiLog;
